import { Flex, Checkbox } from "@chakra-ui/react";
import { Control } from "react-hook-form";
import Field from "components/Input/Field/index";
import { Input } from "@chakra-ui/input";
import { ExportacaoContabilForm } from "features/exportacao-contabil/typings";

export default function RowTableContasBancarias({
  control,
  conta,
  selectable = true,
  index,
  form,
}: {
  control: Control<ExportacaoContabilForm, object>;
  conta: {
    id: string;
    codigoIntegracao?: string | null;
    nome: string;
  };
  selectable?: boolean;
  index: number;
  form: ExportacaoContabilForm;
}) {
  return (
    <Field
      control={control}
      name={`contasBancarias.${index}`}
      render={({ field }) => {
        return (
          <RowTable>
            <Flex flex={4} gap={2} fontWeight="medium">
              <Checkbox
                onChange={
                  selectable
                    ? () =>
                        field.onChange({
                          ...form["contasBancarias"][index],
                          selected: !form["contasBancarias"][index].selected,
                        })
                    : undefined
                }
                isChecked={form["contasBancarias"][index].selected}
                disabled={!selectable}
                onClick={(ev) => ev.stopPropagation()}
              />

              {conta.nome}
            </Flex>

            <Flex flex={2} fontWeight="medium">
              <Input
                disabled={!form["contasBancarias"][index].selected}
                value={form["contasBancarias"][index].codigoIntegracao}
                onChange={(v) =>
                  field.onChange({
                    ...form["contasBancarias"][index],
                    codigoIntegracao: v.target.value,
                  })
                }
              />
            </Flex>
          </RowTable>
        );
      }}
    />
  );
}

export function RowTable({ children }: { children: React.ReactNode }) {
  return (
    <Flex
      w="100%"
      borderX="solid 1px #EBEBEB"
      borderBottom="solid 1px #EBEBEB"
      px={8}
      py={2}
      align="center"
    >
      {children}
    </Flex>
  );
}
